import { render, staticRenderFns } from "./SurveyBlock.vue?vue&type=template&id=ed554ab6"
import script from "./SurveyBlock.vue?vue&type=script&lang=js"
export * from "./SurveyBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../edeone/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports